import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { rsProgress } from "../../RecoilStates";
import { rsAddress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { Link } from "react-router-dom";
import useBreakpoints from "../../hooks/useBreakpoints";
import { UseConsultation } from "./UseConsultation";

export default function Operations(props) {
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const { confirmConsultant, denyConsultant, suspendConsultant } =
    UseConsultation();
  const navigate = useNavigate();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [open, setOpen] = useState({ show: false, type: undefined, text: "" });
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    id: undefined,
    description: "",
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        mt: 2,
      }}
    >
      <Button
        variant="contained"
        color="success"
        onClick={() => {
          setState({ id: props.consultantID, description: props.description });
          setOpen({
            show: true,
            type: "confirm",
            text: "آیا از تایید مشاوره اطمینان دارید؟",
          });
        }}
      >
        تایید
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={() => {
          setState({ id: props.consultantID, description: props.description });
          setOpen({
            show: true,
            type: "deny",
            text: "آیا از عدم تایید مشاوره اطمینان دارید؟",
          });
        }}
      >
        عدم تایید
      </Button>
      <Button
        color="warning"
        variant="contained"
        onClick={() => {
          setState({ id: props.consultantID, description: props.description });
          setOpen({
            show: true,
            type: "suspend",
            text: "آیا از در انتظار قرار دادن مشاوره اطمینان دارید؟",
          });
        }}
      >
        در انتظار
      </Button>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpen({ show: false, type: undefined, text: "" });
        }}
        open={open.show}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Typography sx={{ width: 1, textAlign: "left" }}>
            {open.text}
          </Typography>
          <TextField
            label="توضیحات"
            multiline
            rows={3}
            fullWidth
            value={state.description ? state.description : ""}
            onChange={(evt) => {
              setState({ ...state, description: evt.target.value });
            }}
            size="small"
            variant="outlined"
          />
          <Box sx={{ display: "flex" }}>
            <Button
              onClick={() => {
                if (open.type == "confirm") {
                  confirmConsultant(state, () => {
                    navigate(
                      `/consulate?state=${
                        props.orderState ? props.orderState : "null"
                      }`,
                      {
                        state: {
                          id: props.consultantID,
                          orderState: props.orderState,
                        },
                      }
                    );
                  });
                }
                if (open.type == "deny") {
                  denyConsultant(state, () => {
                    navigate(
                      `/consulate?state=${
                        props.orderState ? props.orderState : "null"
                      }`,
                      {
                        state: {
                          id: props.consultantID,
                          orderState: props.orderState,
                        },
                      }
                    );
                  });
                }
                if (open.type == "suspend") {
                  suspendConsultant(state, () => {
                    navigate(
                      `/consulate?state=${
                        props.orderState ? props.orderState : "null"
                      }`,
                      {
                        state: {
                          id: props.consultantID,
                          orderState: props.orderState,
                        },
                      }
                    );
                  });
                }
              }}
            >
              بله
            </Button>
            <Button
              color="error"
              onClick={() => {
                setOpen({ show: false, type: undefined, text: "" });
              }}
            >
              خیر
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
